<app-legal-layout
  eyebrow="Rechtliches"
  title="Cookie-Richtlinie"
  lastUpdated="Juni 2026">

  <h2>1. Was sind Cookies?</h2>
  <p>
    Cookies sind kleine Textdateien, die beim Besuch einer Website auf Ihrem Endgerät gespeichert werden.
    Sie ermöglichen es uns, Sie für die Dauer einer Sitzung wiederzuerkennen und grundlegende Funktionen
    wie die Anmeldung bereitzustellen. Vergleichbar mit Cookies sind weitere Speichertechnologien (z. B.
    Local Storage, Session Storage), die wir nachfolgend zusammenfassend als „Cookies" bezeichnen.
  </p>

  <h2>2. Welche Cookies setzen wir?</h2>
  <p>
    Auf <strong>get-craftly.de</strong> setzen wir <strong>technisch notwendige Cookies</strong> im
    Sinne von § 25 Abs. 2 Nr. 2 TDDDG. Diese sind unbedingt erforderlich, damit Sie die Plattform
    nutzen können (z. B. um angemeldet zu bleiben). Eine Einwilligung ist hierfür nicht erforderlich.
  </p>
  <p>
    Zusätzlich setzen wir <strong>ausschließlich nach Ihrer ausdrücklichen Einwilligung</strong>
    <strong>Statistik-Cookies</strong> (Google Analytics 4, siehe Ziff. 2a). Ohne Ihre Zustimmung über
    das Cookie-Banner werden diese nicht gesetzt und es findet kein Tracking statt.
  </p>

  <table>
    <thead>
      <tr>
        <th>Cookie</th>
        <th>Anbieter</th>
        <th>Zweck</th>
        <th>Speicherdauer</th>
        <th>Typ</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><code>.AspNetCore.Identity.Application</code></td>
        <td>Kulatrix UG (selbst)</td>
        <td>Aufrechterhaltung der Anmeldung (Session-Cookie, http-only, secure, SameSite=Lax)</td>
        <td>bis zu 7 Tage gleitend</td>
        <td>technisch notwendig</td>
      </tr>
      <tr>
        <td><code>XSRF-TOKEN</code> / Anti-Forgery</td>
        <td>Kulatrix UG (selbst)</td>
        <td>Schutz vor Cross-Site Request Forgery</td>
        <td>Sitzung</td>
        <td>technisch notwendig</td>
      </tr>
    </tbody>
  </table>

  <p>
    Über die genannten technisch notwendigen Cookies hinaus setzen wir <strong>keine</strong> Cookies
    für Marketing, Re-Targeting, A/B-Tests oder Personalisierung. Statistik-Cookies (siehe Ziff. 2a)
    setzen wir ausschließlich mit Ihrer Einwilligung.
  </p>

  <h2>2a. Statistik-Cookies (einwilligungspflichtig)</h2>
  <p>
    Nach Ihrer Einwilligung über das Cookie-Banner nutzen wir <strong>Google Analytics 4</strong>
    (Anbieter: <strong>Google Ireland Ltd.</strong>, Gordon House, Barrow Street, Dublin 4, Irland) zur
    Reichweiten- und Nutzungsanalyse. Rechtsgrundlage ist Ihre Einwilligung nach § 25 Abs. 1 TDDDG
    i. V. m. Art. 6 Abs. 1 lit. a DSGVO. Sie können die Einwilligung jederzeit mit Wirkung für die
    Zukunft über den Link <strong>„Cookie-Einstellungen"</strong> im Footer widerrufen; gesetzte
    Analytics-Cookies werden dabei gelöscht. Details siehe
    <a routerLink="/datenschutz">Datenschutzerklärung</a>.
  </p>

  <table>
    <thead>
      <tr>
        <th>Cookie</th>
        <th>Anbieter</th>
        <th>Zweck</th>
        <th>Speicherdauer</th>
        <th>Typ</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><code>_ga</code></td>
        <td>Google Ireland Ltd.</td>
        <td>Unterscheidung von Nutzern (Reichweitenmessung)</td>
        <td>bis zu 24 Monate</td>
        <td>Statistik (einwilligungspflichtig)</td>
      </tr>
      <tr>
        <td><code>_ga_CY56F8YVJC</code></td>
        <td>Google Ireland Ltd.</td>
        <td>Aufrechterhaltung des Sitzungsstatus (GA4-Property)</td>
        <td>bis zu 24 Monate</td>
        <td>Statistik (einwilligungspflichtig)</td>
      </tr>
    </tbody>
  </table>

  <h2>3. Drittanbieter-Cookies</h2>
  <p>
    Als Drittanbieter-Cookie setzen wir nach Ihrer Einwilligung Google Analytics 4 ein (siehe Ziff. 2a).
    Sofern Sie sich über einen externen Anmeldedienst (Google, Apple) authentifizieren, leitet Sie
    unsere Plattform zudem vorübergehend zur Anmeldeseite des jeweiligen Anbieters weiter. Während dieser
    Weiterleitung können beim Anbieter dortige Cookies gesetzt werden. Hierfür gelten die jeweiligen
    Datenschutz- und Cookie-Hinweise der Anbieter.
  </p>

  <h2>4. Rechtsgrundlage</h2>
  <ul>
    <li>
      Für <strong>technisch notwendige Cookies</strong>: § 25 Abs. 2 Nr. 2 TDDDG i. V. m. Art. 6 Abs. 1
      lit. b oder lit. f DSGVO.
    </li>
    <li>
      Für <strong>nicht notwendige Cookies</strong> (sobald wir solche einsetzen sollten): § 25 Abs. 1
      TDDDG i. V. m. Art. 6 Abs. 1 lit. a DSGVO – ausschließlich auf Grundlage Ihrer Einwilligung über
      das dann eingeblendete Cookie-Banner.
    </li>
  </ul>

  <h2>5. Steuerung und Löschung von Cookies</h2>
  <p>
    Sie können Ihren Browser so einstellen, dass das Speichern von Cookies generell verhindert wird oder
    Sie vor dem Setzen eines Cookies informiert werden. Bereits gesetzte Cookies können Sie jederzeit
    über die Einstellungen Ihres Browsers löschen. Bitte beachten Sie, dass die volle Funktionalität
    unserer Plattform bei Deaktivierung notwendiger Cookies eingeschränkt sein kann.
  </p>
  <p>Anleitungen für die gängigen Browser:</p>
  <ul>
    <li>
      Chrome:
      <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener">support.google.com/chrome/answer/95647</a>
    </li>
    <li>
      Firefox:
      <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen" target="_blank" rel="noopener">support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen</a>
    </li>
    <li>
      Safari:
      <a href="https://support.apple.com/de-de/guide/safari/sfri11471/mac" target="_blank" rel="noopener">support.apple.com/de-de/guide/safari/sfri11471/mac</a>
    </li>
    <li>
      Edge:
      <a href="https://support.microsoft.com/de-de/microsoft-edge" target="_blank" rel="noopener">support.microsoft.com/de-de/microsoft-edge</a>
    </li>
  </ul>

  <h2>6. Änderungen</h2>
  <p>
    Wir behalten uns vor, diese Cookie-Richtlinie zu aktualisieren, sobald sich Funktionen oder
    eingesetzte Dienste der Plattform ändern. Mit Einführung optionaler Cookies wird ein Consent-Banner
    ergänzt; nicht notwendige Cookies werden dann erst nach Ihrer Einwilligung gesetzt.
  </p>

  <h2>7. Kontakt</h2>
  <p>
    Fragen zur Verwendung von Cookies richten Sie bitte an:<br>
    <strong><a href="mailto:datenschutz&#64;kulatrix.com">datenschutz&#64;kulatrix.com</a></strong>
  </p>

</app-legal-layout>
